var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPos = function SvgPos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#42EC9A",
    d: "M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#42EC9A",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M16 10a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#42EC9A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M6.5 14h1M10.5 14h1M6.5 17h1M6.5 20h1M10.5 17h1M10.5 20h1M14.5 14h1M14.5 17h1M14.5 20h1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#42EC9A",
    strokeWidth: 2,
    d: "M3.283 2.407C3.408 1.557 4.15 1 5.009 1h11.982c.859 0 1.6.557 1.726 1.407C18.86 3.37 19 4.864 19 7c0 3.223-.321 10.603-.482 14.098A1.995 1.995 0 0 1 16.524 23H5.476a1.995 1.995 0 0 1-1.994-1.902C3.32 17.603 3 10.223 3 7c0-2.136.141-3.63.283-4.593Z"
  })));
};
export default SvgPos;